import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body text-center py-3" }

import { computed } from "vue";
import { Variants } from "@/interface/gloabl";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertMessage',
  props: {
    variant: { default: "secondary" }
  },
  setup(__props: any) {

const props = __props;

const classNames = computed(() => {
  const { variant } = props;
  const borderColor = `border-${variant}`;
  const bgColor = `bg-${variant == "primary" ? "primary-light" : "light"}`;
  return [borderColor, bgColor];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([classNames.value, "card border-bold rounded-lg shadow-sm mb-3"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})